<!--
 * @Author: your name
 * @Date: 2021-11-22 10:18:45
 * @LastEditTime: 2021-11-24 21:53:24
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /static-pc/src/layout/Layout.vue
-->
<template>
  <el-container direction='vertical'>
    <Header></Header>
    <el-main class="content-main">
      <slot></slot>
    </el-main>
    <Footer></Footer>
  </el-container>
</template>
<script>
import Header from './Header'
import Footer from './Footer'
export default {
  name: 'Layout',
  components: {
    Header,
    Footer
  }
}
</script>
<style lang="scss" scoped>
  .el-main {
    padding: 0;
    overflow: visible;
  }
</style>